import * as React from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import { Box, Typography } from '@mui/material';


interface WarningDialogProps {
  open: boolean;
  onAccept: () => void;
  onCancell: () => void;
  texto: string;
}

export default function WarningDialog(props: WarningDialogProps) {
  const { open, onAccept, onCancell, texto } = props;

  return (
    <div>
      <Dialog open={open}>
        <DialogTitle>Atencion</DialogTitle>
        <DialogContent>
          <Box style={{ marginTop: 24 }}>
            <Typography>{texto}</Typography>
          </Box>
        </DialogContent>
        <DialogActions>
          <Button onClick={onAccept}>Aceptar</Button>
          <Button onClick={onCancell}>Cancelar</Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}
